import { ListItemSelectProps } from '.';

// This object should contain a mock value for each required prop of this component
export const requiredProps: ListItemSelectProps = {};

// This array should contain an object only for tests you wish to run on all compliance tests
const sharedTests = [
  {
    title: 'render',
    props: {
      ...requiredProps,
    } as ListItemSelectProps,
  },
];

export const testkitTests = [
  {
    title: 'render',
    props: {
      ...requiredProps,
      title: 'List item select',
      size: 'small',
      suffix: 'Suffix',
    } as ListItemSelectProps,
  },
];

export const ssrTests = [...sharedTests];

export const a11yTests = [...sharedTests];
